import React, {Component} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {BUTTON_STYLE, BUTTON_COLOR} from '../../constants';
import Button from '../../forecast-app/shared/components/buttons/button/button';
import * as tracking from '../../tracking';

class OnboardingCard extends Component {
	componentDidMount() {
		tracking.trackPage('trial-end-onboarding');
	}

	selectOnboarding(val) {
		this.props.selectOnboarding(val);
	}
	render() {
		const {formatMessage, formatNumber} = this.props.intl;
		const planHasOnboarding = !!this.props.onboarding;
		const selectedTier = this.props.selectedTier;
		let onboardingPrice = 0;
		if (selectedTier === 'PRO' || selectedTier === 'ENTERPRISE') {
			if (this.props.currency === 'DKK') {
				onboardingPrice = 15000;
			} else {
				onboardingPrice = 1999;
			}
		} else {
			if (this.props.currency === 'DKK') {
				onboardingPrice = 7500;
			} else {
				onboardingPrice = 999;
			}
		}

		return (
			<div className={'onboarding-card'} data-cy={'onboarding'}>
				<div className="trial-end-card large">
					<h3 className="no-top-margin">{formatMessage({id: 'settings_subscription.onboarding'})}</h3>
					<div className="onboarding-description">
						<span>
							<FormattedMessage id="onboarding.description_1" />
						</span>
						<span>
							<FormattedMessage id="onboarding.description_2" />
						</span>
						<span>
							<FormattedMessage id="onboarding.description_3" />
						</span>
					</div>
					<div tabIndex={-1} className="onboarding-selector-wrapper" id="onboarding-selector-wrapper">
						<div>
							<div className="title required">{formatMessage({id: 'settings_subscription.onboarding'})}</div>
							{planHasOnboarding ? (
								<div className="price">{`${this.props.currencySymbol}${formatNumber(onboardingPrice, {format: 'rounded_two_decimal'})} ${formatMessage({
									id: 'settings_subscription.one_time_fee',
								})}`}</div>
							) : (
								<div className="onboarding-unavailable">{formatMessage({id: 'trial_end.onboarding_unavailable'})}</div>
							)}
						</div>
						{/*<CheckBox greenInverted={'true'} isChecked={this.props.isOnboarding} onChange={this.toggleOnboarding.bind(this)} />*/}
						{this.props.noOnboardingSelectedError ? (
							<div className="onboarding-error" data-cy={'onboarding-error'}>
								{formatMessage({id: 'settings_subscription.onboarding_error'})}
							</div>
						) : (
							<div className="onboarding-error-empty"> </div>
						)}
						<div className="onboarding-radio-wrapper">
							<div className="onboarding-radio">
								<div className="radio-wrapper">
									<input type="radio" id="yes-radio" name="onboarding" onChange={this.selectOnboarding.bind(this, true)} checked={this.props.isOnboarding === true} tabIndex={0} disabled={!planHasOnboarding} />
									<label htmlFor="yes-radio" data-cy={'onboarding-yes-radio'}>
										{formatMessage({id: 'onboarding.yes_onboarding'})}
									</label>
								</div>
							</div>
							<div className="onboarding-radio">
								<div className="radio-wrapper">
									<input type="radio" id="no-radio" name="onboarding" onChange={this.selectOnboarding.bind(this, false)} checked={this.props.isOnboarding === false} disabled={!planHasOnboarding} />
									<label htmlFor="no-radio" data-cy={'onboarding-no-radio'}>
										{formatMessage({id: 'onboarding.no_thanks'})}
									</label>
								</div>
							</div>
						</div>
					</div>

					<div className="buttons">
						<Button className="back-button" onClick={this.props.setPage.bind(this, 'LICENSING')} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.WHITE} text={formatMessage({id: 'common.back'})} cy={'back-button'} />
						<Button className="next-button" onClick={this.props.setPage.bind(this, 'COMPANY_DETAILS')} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.GREEN} text={formatMessage({id: 'common.next'})} cy={'next-button'} />
					</div>
				</div>
			</div>
		);
	}
}
OnboardingCard.propTypes = {};
export default injectIntl(OnboardingCard);
